import './icon.css';

function Icon({ iconClass, size = 24 }) {
    return (
        <i className={`icon ${iconClass}`} style={{width: size, height: size}}></i>
    );
}

export default Icon;